// 카테고리 매핑 유틸리티
export const CATEGORY_MAP = {
  PROGRAM: "프로그램",
  PORTFOLIO: "포트폴리오",
  INQUERY_ACTIVITY_PLAN_REPORT: "탐구 활동 계획 보고서",
  BOOK_PLUS: "북 플러스",
} as const;

export type CategoryKey = keyof typeof CATEGORY_MAP;

// 카테고리 키를 한글로 변환하는 함수
export const getCategoryLabel = (category: string): string => {
  return CATEGORY_MAP[category as CategoryKey] || category;
};

// 한글을 카테고리 키로 변환하는 함수
export const getCategoryKey = (label: string): string => {
  const entry = Object.entries(CATEGORY_MAP).find(
    ([_, value]) => value === label
  );
  return entry ? entry[0] : label;
};
